import { useEffect } from "react";
import { UseFormReturn, useForm, useWatch } from "react-hook-form";

import useCountryList from "../../hooks/useCountryList.hook";
import CountrySelectorInput from "../reuseables/countrySelectorInput.comp";

// This return a single countryIso instead of countryIds[]
export default function CountrySelectorInputSingle({
  methods,
  defaultCountryCode,
}: {
  methods: UseFormReturn<any>;
  defaultCountryCode?: string;
}) {
  const internalMethods = useForm<{ countryIds: string[] }>();
  const countryIds = useWatch({ name: "countryIds", control: internalMethods.control });

  const { data: countryList, isFetched } = useCountryList();

  useEffect(() => {
    if (!defaultCountryCode) return;
    if (!countryList) return;

    const country = countryList.find((c) => c.code === defaultCountryCode);
    if (!country) return;

    internalMethods.setValue("countryIds", [country.id]);
  }, [internalMethods, countryList, defaultCountryCode]);

  useEffect(() => {
    if (countryList && countryIds && countryIds.length > 0) {
      const country = countryList.find((c) => c.id === countryIds[0]);

      if (country) {
        methods.setValue("countryIso", country.iso);
        // internalMethods.setValue("countryIds", [country.id]);
      }
    }
  }, [countryList, methods, countryIds, internalMethods]);

  if (!isFetched) return null;

  return <CountrySelectorInput methods={internalMethods} multiple={false} />;
}
